import { Jurisdiction } from './types';

export const getJurisdictionData = (jurisdiction: string): Jurisdiction => {
  if (!jurisdiction) {
    return { disableChat: false, showTableLimitsPopup: false };
  }
  const JurisdictionOptions = jurisdiction.split(',').map((value: string) => value.toLowerCase());
  return {
    disableChat: JurisdictionOptions.includes(`disable_chat`) ?? false,
    showTableLimitsPopup: JurisdictionOptions.includes(`show_table_limits_popup`) ?? false,
  };
};
